import React, { useCallback, useMemo } from 'react';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import { gql } from '@apollo/client';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import TabContactsTable from './components/TabContactsTable/TabContactsTable';
import TabVacationCalendar from './components/TabVacationCalendar/TabVacationCalendar';
import withAuthentication from 'Components/withAuthentication';
import ReactGA from 'Shared/analytics';

export const queryGetColleagues = gql`
  query TabContactsTableQuery @api(name: root) {
    colleagues {
      user {
        id
        email
        firstName
        lastName
      }
      phone
      birthDate
      avatar
      telegram
    }
  }
`;

const Colleagues = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <div className="tab-colleagues">
      <Route path="/employee/colleagues" exact render={() => <Redirect to="/employee/colleagues/contacts/" />} />
      <Switch>
        <Route strict exact path="/employee/colleagues/contacts/" component={TabContactsTable} />
        <Route strict exact path="/employee/colleagues/vacations/" component={TabVacationCalendar} />
      </Switch>
    </div>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.push(`/employee/colleagues/${tabClicked}/`);
        ReactGA.pageview(`/employee/colleagues/${tabClicked}/`, 'Collegues' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Colleagues',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'contacts',
                label: 'CONTACTS',
              },
              {
                id: 'vacations',
                label: 'VACATIONS',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'colleagues',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Colleagues);
